module.exports = __webpack_public_path__ + "media/images/smart_phone/delivery_status_notifications/ico_derivery01-c09bed7bd82547e9703393abbd27e5da.png";